import React from 'react';
import { motion } from 'framer-motion';
import { Globe, MapPin, MessageCircle } from 'lucide-react';
export const BringToYourCitySection = () => {
  return <section id="bring-to-city" className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-111">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black z-0" data-id="element-112"></div>
      <div className="container mx-auto px-4 relative z-10 max-w-6xl" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-24" data-id="element-114">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-115">
            Global Expansion
          </p>
          <h2 className="font-serif text-5xl md:text-7xl text-white mb-8" data-id="element-116">
            BRING THIS
            <br data-id="element-117" />
            <span className="text-amber-400" data-id="element-118">TO YOUR CITY</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-119"></div>
          <p className="text-xl text-white/70 max-w-3xl mx-auto font-light" data-id="element-120">
            This groundbreaking celebration of Sikh heritage can travel to your
            community
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-20" data-id="element-121">
          {/* Global Tour Card */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-122">
            <div className="flex items-center mb-8" data-id="element-123">
              <Globe className="w-8 h-8 text-amber-400 mr-4" data-id="element-124" />
              <h3 className="font-serif text-3xl text-amber-400" data-id="element-125">
                Global Tour Potential
              </h3>
            </div>
            <p className="text-white/70 mb-8 font-light leading-relaxed" data-id="element-126">
              After our Toronto premiere, we're planning a limited global tour
              of this immersive experience to select cities with significant
              Sikh and cultural communities.
            </p>
            <div className="space-y-4" data-id="element-127">
              {['Complete turnkey experience with all technology and culinary partnerships', 'Adaptable to various venues including museums, cultural centers, and event spaces', 'Opportunity to incorporate local Sikh history and community elements', 'Flexible scheduling for 2-7 day exhibition periods'].map((point, i) => <div key={i} className="flex items-start" data-id="element-128">
                  <span className="text-amber-400 mr-3 mt-1" data-id="element-129">—</span>
                  <p className="text-white/60 font-light" data-id="element-130">{point}</p>
                </div>)}
            </div>
          </motion.div>
          {/* Express Interest Card */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-131">
            <div className="flex items-center mb-8" data-id="element-132">
              <MapPin className="w-8 h-8 text-amber-400 mr-4" data-id="element-133" />
              <h3 className="font-serif text-3xl text-amber-400" data-id="element-134">
                Express Interest
              </h3>
            </div>
            <p className="text-white/70 mb-8 font-light leading-relaxed" data-id="element-135">
              Want to bring "Life in the Sikh Kingdoms" to your city? Let us
              know! We're looking for local partners, venues, and community
              organizations to help expand this experience.
            </p>
            <div className="border border-amber-400/30 p-8 bg-black/40" data-id="element-136">
              <p className="text-amber-400 text-lg font-light mb-6 text-center" data-id="element-137">
                Contact us directly to discuss bringing this experience to your
                city
              </p>
              <motion.a href="https://wa.me/14169998778?text=I%20am%20interested%20to%20sponsor%20Life%20in%20the%20Sikh%20Kingdoms%20in%20my%20city%20of%20…" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="block w-full bg-amber-400 hover:bg-amber-500 text-black font-light py-4 px-8 text-center transition-colors duration-300 flex items-center justify-center gap-3" data-id="element-138">
                <MessageCircle className="w-5 h-5" data-id="element-139" />
                Contact via WhatsApp
              </motion.a>
              <p className="text-white/50 text-sm mt-4 text-center font-light" data-id="element-140">
                Our team will respond within 24 hours to discuss partnership
                opportunities
              </p>
            </div>
          </motion.div>
        </div>
        {/* Bottom Quote */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center max-w-3xl mx-auto" data-id="element-141">
          <p className="text-2xl text-amber-400 font-light italic mb-4" data-id="element-142">
            "Our vision is to bring this experience to Sikh communities
            worldwide."
          </p>
          <div className="w-16 h-px bg-amber-400/30 mx-auto mb-6" data-id="element-143"></div>
          <p className="text-white/60 font-light" data-id="element-144">
            Cities with significant interest will be prioritized for our
            2027-2028 global tour. Community partnerships make this possible.
          </p>
        </motion.div>
      </div>
    </section>;
};